import * as z from "zod"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(z.string(), jsonSchema)]))

export const source_specDbModel = z.object({
  package: z.string(),
  version: z.string(),
  specs: jsonSchema,
  timestamp: z.coerce.date(),
  error: z.string().nullish(),
})
